import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { TextInput } from '@tecuity/granite-ui'
import { /*SetPayments,*/ UpdatePaymentTotals } from '../PostPaymentActions'
import { SET_TOTALS_VALID } from '../PostPaymentReducer'

const PostPaymentBatch = () => {
  const dispatch = useDispatch()
  const { payments } = useSelector((state) => state.postPayment, shallowEqual)
  const [values, setValues] = useState([])

  const amounts = useMemo(() => {
    let amounts = {}
    payments.forEach((payment) => (amounts[payment.type] = payment.amount))
    return amounts
  }, [payments])

  const checkValidTotals = (vals) => {
    const isValid = payments.every((payment) => {
      return Number(vals[payment.id]) === Number(amounts[payment.type])
    })
    dispatch({ type: SET_TOTALS_VALID, areTotalsValid: isValid })
  }

  const tableColumns = [
    { field: 'type', flex: 0.7, minWidth: 20, headerName: 'Payment Type', disableColumnMenu: true },
    {
      field: 'amount',
      flex: 0.3,
      minWidth: 20,
      headerName: 'Amount On Hand',
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <React.Fragment>
            <TextInput
              aria-label={'Amount On Hand'}
              placeholder="0.00"
              onChange={(e) => {
                values[params.row.id] = e.target.value
                checkValidTotals(values)
                dispatch(UpdatePaymentTotals(payments, values))
              }}
              type="number"
            />
            {amounts[params.row.type] ? (
              <span style={{ marginLeft: '20px' }}> ${amounts[params.row.type]}</span>
            ) : null}
          </React.Fragment>
        )
      },
    },
  ]

  useEffect(() => {
    setValues(Array(payments.length))
  }, [payments])

  return (
    <React.Fragment>
      <GraniteDataGrid
        columns={tableColumns}
        rows={payments}
        pagination={undefined}
        rowsPerPageOptions={[25, 50, 100]}
        checkboxSelection={false}
      />
    </React.Fragment>
  )
}

export default PostPaymentBatch
